import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import styled from "styled-components";

interface AsSatusProps {
  countArray?: any;
  brand?: string;
}

const setBrand = (brandCode?: string) => {
  switch (brandCode) {
    case "M":
      return [true, false, false, false, false, false];
    case "I":
      return [false, true, false, false, false, false];
    case "X":
      return [false, false, true, false, false, false];
    case "V":
      return [false, false, false, true, false, false];
    case "W":
      return [false, false, false, false, true, false];
    case "ST":
      return [false, false, false, false, false, true];
    default:
      return [false, false, false, false, false, false];
  }
};
const getBrand = (array: boolean[]) => {
  const index = array.indexOf(true);
  switch (index) {
    case 0:
      return "MLB";
    case 1:
      return "MLB KIDS";
    case 2:
      return "Discovery";
    case 3:
      return "DUVETICA";
    case 4:
      return "SUPRA";
    case 5:
      return "Sergio Tacchini";
    default:
      return;
  }
};

const AsStatusItem = (props: AsSatusProps) => {
  const brandCheckArray = setBrand(props?.brand);
  const selectedBrand = brandCheckArray.indexOf(true) !== -1;

  return (
    <>
      {!isEmpty(props.countArray) ? (
        <LinkWrap>
          <li>
            <StyledLink
              to="/as-list/"
              state={{
                process: selectedBrand ? ["접수중", getBrand(brandCheckArray)] : ["접수중"],
                checkArray: [true, false, false, false, false, false],
                brand: brandCheckArray,
              }}
            >
              <span className="text">접수중</span>
              <span className="num">{props.countArray[20]}</span>
            </StyledLink>
          </li>
          <li>
            <StyledLink
              to="/as-list/"
              state={{
                process: selectedBrand ? ["업체배정", getBrand(brandCheckArray)] : ["업체배정"],
                checkArray: [false, true, false, false, false, false],
                brand: brandCheckArray,
              }}
            >
              <span className="text">업체배정</span>
              <span className="num">{props.countArray[40]}</span>
            </StyledLink>
          </li>
          <li>
            <StyledLink
              to="/as-list/"
              state={{
                process: selectedBrand ? ["견적진행", getBrand(brandCheckArray)] : ["견적진행"],
                checkArray: [false, false, true, false, false, false],
                brand: brandCheckArray,
              }}
            >
              <span className="text">견적진행</span>
              <span className="num">{props?.countArray[60]}</span>
            </StyledLink>
          </li>
          <li>
            <StyledLink
              to="/as-list/"
              state={{
                process: selectedBrand ? ["A/S진행", getBrand(brandCheckArray)] : ["A/S진행"],
                checkArray: [false, false, false, true, false, false],
                brand: brandCheckArray,
              }}
            >
              <span className="text">A/S진행</span>
              <span className="num">{props.countArray[80]}</span>
            </StyledLink>
          </li>
          <li>
            <StyledLink
              to="/as-list/"
              state={{
                process: selectedBrand ? ["완료", getBrand(brandCheckArray)] : ["완료"],
                checkArray: [false, false, false, false, true, false],
                brand: brandCheckArray,
              }}
            >
              <span className="text">완료</span>
              <span className="num">{props.countArray[100]}</span>
            </StyledLink>
          </li>
        </LinkWrap>
      ) : (
        <NoData>
          <p>진행중인 A/S가 없습니다.</p>
        </NoData>
      )}
    </>
  );
};

const NoData = styled.div`
  padding: 45px 15px;
  margin-bottom: 56px;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  color: #000;
  text-align: center;
`;

const LinkWrap = styled.ul`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "stretch")};
  height: 90px;
  margin-bottom: 56px;
  > li {
    flex: 1;
    margin-right: 5px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const StyledLink = styled(Link)`
  display: block;
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")};
  height: 100%;
  padding: 13px 5px 14px;
  border-radius: 4px;
  background-color: #fff;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1));
  font-size: 14px;
  text-align: center;
  .text {
    display: inline-block;
    color: ${({ theme }) => theme.color.tertiary};
  }
  .num {
    display: inline-block;
    color: ${({ theme }) => theme.color.main};
    font-family: "Poppins";
    font-weight: 500;
    font-size: 22px;
  }
`;

export default AsStatusItem;
